<template>
  <div>
    <div class="vx-row mt-2 mb-5">
      <div class="vx-col w-full">
        <div class="flex flex-center">
          <vs-chip transparent color="primary">
            <vs-avatar icon="phone" />
            <span class="bold text-xs">({{ currentDialCode }}) {{ currentPhone }} {{ currentPhoneStatus }}</span>
          </vs-chip>
          <vs-button size="small" radius class="ml-2" icon-pack="feather" icon="icon-edit"
            @click.stop="openPopup"></vs-button>
        </div>
      </div>
      <div class="cx-col w-full ml-5 mt-2 clickable-img" @click="isWhatsappPopUpActive = true">
        <vs-chip color="success" v-if="whatsappMessagingData"><span>WhatsApp enviados</span></vs-chip>
      </div>
    </div>

    <vs-popup :active.sync="isPopupActive" title="Teléfono del solicitante">
      <div class="vx-row">
        <div class="vx-col w-full">
          <h6>Seleccione el tipo de teléfono con que cuenta el solicitante, de las opciones siguientes:</h6>
        </div>

        <div class="vx-col w-full">
          <vs-alert class="h-full mb-3" color="danger" v-if="errorMssg">
            {{ errorMssg }}
          </vs-alert>
        </div>

        <div class="vx-col w-full mt-5">
          <div class="flex">
            <vue-country-code name="dialCode" class="vs-custom dial-code" data-vv-name="dialCode"
              :enableSearchField="true" searchPlaceholderText="Buscar código de país" :enabledCountryCode="true"
              @onSelect="onSelect" :defaultCountry="'MX'" :preferredCountries="['MX']">
            </vue-country-code>

            <vs-input class="w-full" label="Teléfono a 10 dígitos" name="newPhone" v-validate="phoneRules"
              v-model.lazy="newPhone" icon-pack="feather" placeholder="Ingrese" :danger="hasError('newPhone')"
              :danger-text="errorText('newPhone')" :success="isSuccess('newPhone')" />
          </div>
        </div>

        <div class="vx-col w-full mt-6">
          <label for="phone-status">Tipo de teléfono:</label>
          <v-select id="phone-status" name="newPhoneStatus" class="vs-custom" v-model.lazy="newPhoneStatus"
            v-validate="requiredRules" :options="options" :reduce="item => item.value" :clearable="false"
            placeholder="Seleccione">
            <v-error v-if="hasError('newPhoneStatus')" :error="errorText('newPhoneStatus')" />
            <div slot="no-options">No hay coincidencias</div>
          </v-select>
        </div>

        <div class="vx-col w-full mt-20">
          <vs-button color="success" @click.stop="saveApplicantPhoneData">Guardar cambios</vs-button>
        </div>
      </div>
    </vs-popup>

    <vs-popup id="whatsapp-messaging" :active.sync="isWhatsappPopUpActive"
      title="Whatsapp enviados al teléfono del solicitante">
      <vx-card class="mb-4">
        <h1 class="bold big-title m-0">Lista de <span>mensajes</span>.</h1>
        <p class="mb-0">Se presenta información de los últimos <strong>45 días</strong>.</p>
      </vx-card>
      <vx-card>
        <vs-table ref="emailsTable" stripe pagination max-items="20" :data="whatsappMessagingData"
          noDataText="No se econtraron emails de este usuario">
          <template slot="header">
            <h4 class="pill-light">Teléfono: {{ currentPhone }} </h4>
          </template>
          <template slot="thead">
            <vs-th>Estatus</vs-th>
            <vs-th>Tag</vs-th>
            <vs-th>Fecha</vs-th>
            <vs-th>Vista previa</vs-th>
          </template>
          <template slot-scope="{ data }">
            <vs-tr :key="indextr" v-for="(tr, indextr) in data" :data="tr">
              <vs-td>{{ getStatusNamed(tr.response) }}</vs-td>
              <vs-td>{{ tr.template_tag }}</vs-td>
              <vs-td>{{ explicitDateFormat(tr.sent_timestamp) }}</vs-td>
              <vs-td><vs-button radius color="success" icon-pack="feather" icon="icon-eye" size="small"
                  @click.stop="showMessage = true, currentMessage = tr.message"></vs-button></vs-td>
            </vs-tr>
          </template>
        </vs-table>
        <vs-popup id="whatsapp-messaging-detail" :active.sync="showMessage" title="Mensaje">
          <p class="p-format">
            {{ currentMessage }}
          </p>
          <small><strong>Nota: </strong>Se presenta la reconstrucción del mensaje, no se obtiene directamente de whatsapp.</small>
        </vs-popup>
      </vx-card>
    </vs-popup>

  </div>
</template>

<script>
import dateHelper from "@mixins/dateHelper.js"
export default {
  name: "UserPhoneStatus",
  props: {
    userId: { type: [String, Number], required: true }
  },
  mixins: [dateHelper],
  data() {
    return {
      phoneStatus: null,
      phone: null,
      dialCode: '+52',
      newPhone: null,
      phoneId: null,
      newPhoneStatus: null,
      requiredRules: 'required',
      phoneRules: 'required|digits:10',
      errorMssg: null,
      options: [
        { value: 0, label: "Desconocido/No definido" },
        { value: 1, label: "Teléfono fijo" },
        { value: 2, label: "Teléfono celular propio" },
        { value: 5, label: "Teléfono celular de tercero" },
        { value: 3, label: "Celular con Whatsapp (verificado) propio" },
        { value: 6, label: "Celular con Whatsapp (verificado) tercero" },
        // {value: 4, label: "Celular verificado vía SMS (verificado) propio"},
        // {value: 4, label: "Celular verificado vía SMS (verificado) tercero"},
      ],
      whatsappMessagingData: null,
      isWhatsappPopUpActive: false,
      showMessage: false,
      currentMessage: null
    }
  },
  async beforeMount() {
    await this.getApplicantPhoneData();
    await this.getWhatsappMessagingData();
  },
  computed: {
    isPopupActive: {
      get() {
        return this.$store.state.isPhonePopupActive;
      },
      set(val) {
        this.$store.commit("TOGGLE_IS_PHONE_POPUP_ACTIVE", val);
      }
    },
    currentPhone() {
      if (this.phone != null) {
        return this.phone;
      }
      else {
        return "Sin teléfono registrado";
      }
    },
    currentDialCode() {
      if (this.dialCode != null) {
        return this.dialCode;
      }
      return "";
    },
    currentPhoneStatus() {
      if (this.phone == null) {
        return null;
      }
      switch (this.phoneStatus) {
        default:
          return '(tel. desconocido)';
        case 1:
          return '(tel. fijo)';
        case 2:
          return '(tel. celular propio)';
        case 5:
          return '(tel. celular de tercero)';
        case 3:
          return '(tel. celular con Whatsapp propio)';
        case 6:
          return '(tel. celular con Whatsapp de tercero)';
        case 4:
          return '(tel. celular con SMS)';
      }
    }
  },
  methods: {
    onSelect({ dialCode }) {
      this.dialCode = `+${dialCode}`;
    },
    async getWhatsappMessagingData() {
      try {
        const res = await axios.get(`/api/v1/userInfo/get-messages-by-phone/${this.phone}`);
        this.whatsappMessagingData = res.data;
      } catch (error) {
        console.log(error);
      }
    },
    async getApplicantPhoneData() {
      try {
        const res = await axios.get(`/api/v1/userInfo/${this.userId}/getMainPhone`);
        this.phone = res.data.phone;
        this.phoneStatus = res.data.phone_status;
        this.dialCode = res.data.dial_code ? res.data.dial_code : '+52';
        this.phoneId = res.data.phone_id;
      }
      catch (e) {
      }
    },
    async saveApplicantPhoneData() {
      this.errorMssg = null;
      let valid = await this.$validator.validateAll();
      if (!valid) {
        this.errorMssg = "Debe completar todos los campos";
        return;
      }
      await this.doSaveApplicantPhoneData();
    },
    async doSaveApplicantPhoneData() {
      this.showLoading(true)
      try {
        let payload = {
          phone: this.newPhone,
          phone_status: this.newPhoneStatus
          , dial_code: this.dialCode
          , phone_id: this.phoneId
        };
        const res = await axios.post(`/api/v1/userInfo/${this.userId}/setMainPhone`, payload);
        this.phone = res.data.phone;
        this.phoneStatus = res.data.phone_status;
        this.dialCode = res.data.dial_code;
        this.phoneId = res.data.phoneId;
        await this.$emit("updated", this.phone);
        this.saveSuccessNotif();
        this.isPopupActive = false;
      }
      catch (e) {
        this.errorMssg = "Ha ocurrido un error actualizando la información. Intente más tarde.";
      }
      this.showLoading(false)
    },
    openPopup() {
      this.errorMssg = null;
      this.newPhone = this.phone;
      this.newPhoneStatus = this.phoneStatus;
      this.isPopupActive = true;
    },

    hasError(val) {
      return this.errors.has(val);
    },
    errorText(val) {
      return this.errors.first(val);
    },
    isSuccess(val) {
      let ff = this.fields[val];
      return (ff && ff.required && ff.valid);
    },
    getStatusNamed(status) {
      const statuses = {
        'DELIVERED': "ENTREGADO",
        'IN_PROCESS': "PROCESANDO",
        'FAILED': "CON ERROR",
        'ACCEPTED': "ACEPTADO",
        'SENT': "ENVIADO"
      }

      return statuses[status] || "Estatus no registrado";
    }
  }
}
</script>

<style>
.vs-popup--header {
  background-color: #28de18 !important;
}

.vs-popup--title h3 {
  color: white !important;
}

#whatsapp-messaging .vs-popup {
  width: 60% !important;
}

#whatsapp-messaging-detail {
  z-index: 900000 !important;
}

.p-format {
  white-space: pre-wrap !important;
  line-height: 1rem;
  font-size: .9rem;
  font-family: system-ui;
  border: solid 1px #f5f5f5;
  border-radius: 5px;
  padding: 1rem;
  background-color: #f5f5f5;
  margin: 1rem;
  -webkit-box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);
}
</style>